import {
    Box, Text, Button, Input, Flex, FormControl, FormLabel, Collapse, Select,
    Progress, Grid, Icon, useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter,
    VStack, Tabs, TabList, Tab, TabPanels, TabPanel, HStack, Heading, Alert, AlertIcon, Divider
} from '@chakra-ui/react';
import { FaInbox, FaSlidersH, FaShoppingCart } from 'react-icons/fa';
import ScrollToTop from "../components/ScrollToTop";
import Preloader from "../components/Preloader";
import React, { useState, useEffect, useMemo } from "react";
import MultipleSelect from "../components/MultipleSelect";
import { getVendasML, criarObsVenda, apagarObsVenda, setAtribuicaoVendaVendedor, getMetricasVendedor, getNegociacoesVendas } from "../services/api";
import { checkPermission } from '../services/permission';
import PainelPagamentos from '../components/comissoes/pagamentos/PainelPagamentos';
import FormNegociacao from '../components/vendas-vendedor/FormNegociacao';
import ModalNegociacao from '../components/vendas-vendedor/ModalNegociacao';
import { NEGOCIACAO_VAZIA, paraApi, telefoneDoCadastro, temNegociacao, validarNegociacao } from '../components/vendas-vendedor/negociacao';
import MultipleSelectFornecedoresVendas from "../components/MultipleSelectFornecedoresVendas";
import MetricasVendas from '../components/MetricasVendasVendedor';
import PainelComissoes from '../components/comissoes/PainelComissoes';
import CardPedido from '../components/vendas-vendedor/CardPedido';
import { useUsuarios, semBloqueados } from '../hooks/useUsuarios';

const TIPO_ADMIN = 1;
const TIPO_VENDEDOR = 2;

const usuarioLogado = () => {
    try {
        return JSON.parse(window.localStorage.getItem("user")) || null;
    } catch {
        return null;
    }
};

const resolverVendedorPadrao = () => {
    const user = usuarioLogado();
    return Number(user?.tipo) === TIPO_VENDEDOR ? user.id : null;
};

const VendasVendedor = () => {
    const toast = useToast();
    const [pedidos, setPedidos] = useState([]);
    const [buscaBool, setBuscaBool] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingLinear, setLoadingLinear] = useState(false);
    const [totalVendas, setTotalVendas] = useState([]);
    const [filtroBusca, setFiltroBusca] = useState("");
    const [filtroProduto, setFiltroProduto] = useState("");
    const [filtroCliente, setFiltroCliente] = useState("");
    const [filtroAtribuicao, setFiltroAtribuicao] = useState('todos');

    const pedidosFiltrados = useMemo(() => {
        if (filtroAtribuicao === 'atribuidas') return pedidos.filter(p => p.vendedor);
        if (filtroAtribuicao === 'sem_atribuicao') return pedidos.filter(p => !p.vendedor);
        return pedidos;
    }, [pedidos, filtroAtribuicao]);

    const [vendedorSelecionado, setVendedorSelecionado] = useState(resolverVendedorPadrao());

    // Vendedor enxerga apenas o proprio nome; a troca e so para administradores.
    const usuario = useMemo(() => usuarioLogado(), []);
    const ehAdmin = Number(usuario?.tipo) === TIPO_ADMIN;
    // Mesma regra da API: admin ou quem tem acoes gerenciais.
    const gerencia = ehAdmin || checkPermission();
    const usuarios = useUsuarios();
    const vendedores = useMemo(() => semBloqueados(usuarios).filter((u) => Number(u.tipo) === TIPO_VENDEDOR), [usuarios]);
    const meuCadastroDeVendedor = useMemo(() => vendedores.find((v) => v.id === usuario?.id) || null, [vendedores, usuario]);
    const vendedoresVisiveis = ehAdmin ? vendedores : (meuCadastroDeVendedor ? [meuCadastroDeVendedor] : vendedores);
    const vendedorAtual = vendedores.find((v) => v.id === vendedorSelecionado) || null;

    useEffect(() => {
        if (vendedores.length === 0) return;
        setVendedorSelecionado((atual) => (
            vendedores.some((v) => v.id === atual) ? atual : (meuCadastroDeVendedor?.id ?? vendedores[0].id)
        ));
    }, [vendedores, meuCadastroDeVendedor]);

    const [metricas, setMetricas] = useState(null);
    const [loadingMetricas, setLoadingMetricas] = useState(true);

    useEffect(() => {
        consultarVendas(true);
    }, [vendedorSelecionado]);

    useEffect(() => {
        const fetchMetricas = async () => {
            if (!vendedorSelecionado) return;
            try {
                setLoadingMetricas(true);
                const response = await getMetricasVendedor(vendedorSelecionado);
                if (response) {
                    setMetricas(response);
                } else {
                    setMetricas(null);
                }
            } catch (error) {
                console.error("Erro ao buscar métricas:", error);
                toast({
                    title: 'Erro ao carregar métricas.',
                    status: 'error',
                    isClosable: true,
                });
            } finally {
                setLoadingMetricas(false);
            }
        };

        fetchMetricas();
    }, [vendedorSelecionado]);

    const [selectedOptionsStatusFornecedor, setSelectedOptionsStatusFornecedor] = useState([{ label: "Morelate", value: "morelate" },
    { label: "Vannucci", value: "vannucci" }, { label: "Isapa", value: "isapa" }, { label: "BRCompany", value: "brcompany" }, { label: "Autolatina", value: "autolatina" }, { label: "LNG", value: "lng" }, { label: "CBA", value: "cba" }, { label: "MSAM", value: "msam" }, { label: "BL Parts", value: "blparts" }]);
    const [filtroFornecedor, setFiltroFornecedor] = useState("morelate-vannucci-isapa-brcompany-autolatina-lng-cba-msam-blparts");
    const handleSelectedOptionsFornecedoresChange = (options) => {
        setSelectedOptionsStatusFornecedor(options);
        let concatenatedString = "";
        if (options && options.length > 0) {
            for (let i = 0; i < options.length; i++) {
                if (options[i] && options[i].value) {
                    concatenatedString += options[i].value;
                    if (i !== options.length - 1) {
                        concatenatedString += "-";
                    }
                }
            }
        }
        handleChangeFiltroFornecedores(concatenatedString);
    };
    const handleChangeFiltroFornecedores = (value) => {
        setFiltroFornecedor(value);
    };


    const [filtroMktplaces, setFiltroMktplaces] = useState("2-5-6");

    const [vendaAtribuicao, setVendaAtribuicao] = useState(null);
    const [isModalOpenConfirmAtribuicao, setIsModalOpenConfirmAtribuicao] = useState(false);
    const [formNegociacao, setFormNegociacao] = useState(NEGOCIACAO_VAZIA);
    const [erroAtribuicao, setErroAtribuicao] = useState(null);
    const [salvandoAtribuicao, setSalvandoAtribuicao] = useState(false);
    const closeModalConfirmAtribuicao = () => setIsModalOpenConfirmAtribuicao(false);
    const openModalConfirmAtribuicao = (venda) => {
        setVendaAtribuicao(venda);
        setFormNegociacao({
            ...NEGOCIACAO_VAZIA,
            cliente_nome: venda?.dados_cliente?.nome || '',
            cliente_telefone: telefoneDoCadastro(venda?.dados_cliente?.telefone),
        });
        setErroAtribuicao(null);
        setIsModalOpenConfirmAtribuicao(true);
    };
    const handleCancelAtribuicao = () => {
        if (salvandoAtribuicao) return;
        setVendaAtribuicao(null);
        closeModalConfirmAtribuicao();
    };
    const handleClickAtribuirVenda = async () => {
        var status = 1;
        if (vendaAtribuicao.vendedor) {
            status = 0;
        }
        // Ao pegar a venda, a negociacao vai junto (#1517); o vendedor informa ao menos o canal.
        let negociacao = null;
        if (status === 1) {
            const problema = validarNegociacao(formNegociacao, { canalObrigatorio: !gerencia });
            if (problema) {
                setErroAtribuicao(problema);
                return;
            }
            negociacao = temNegociacao(formNegociacao) ? paraApi(formNegociacao) : null;
        }
        setSalvandoAtribuicao(true);
        const erro = await handleAtribuicaoVenda(vendaAtribuicao.id_taga, status, negociacao);
        setSalvandoAtribuicao(false);
        if (erro) {
            setErroAtribuicao(erro);
            return;
        }
        setVendaAtribuicao(null);
        closeModalConfirmAtribuicao();
    };

    // Negociacoes das vendas atribuidas que estao na tela (#1517).
    const [negociacoes, setNegociacoes] = useState({});
    const [pedidoNegociacao, setPedidoNegociacao] = useState(null);
    const idsAtribuidos = useMemo(
        () => pedidos.filter((p) => p.vendedor && p.id_taga).map((p) => p.id_taga).join(','),
        [pedidos]
    );
    const carregarNegociacoes = async (ids) => {
        if (!ids.length) return;
        try {
            const r = await getNegociacoesVendas(ids);
            setNegociacoes((atual) => ({ ...atual, ...(r?.negociacoes || {}) }));
        } catch (e) {
            console.error('Erro ao carregar negociações:', e);
        }
    };
    useEffect(() => {
        carregarNegociacoes(idsAtribuidos ? idsAtribuidos.split(',').slice(0, 500) : []);
    }, [idsAtribuidos]);
    const podeEditarNegociacao = (pedido) => gerencia || Number(pedido?.vendedor?.id) === Number(usuario?.id);

    const STATUS_TODOS_OPTIONS = [
        { label: "Confirmadas", value: "confirmada" },
        { label: "Para enviar", value: "enviar" },
        { label: "Em trânsito", value: "transito" },
        { label: "Concluídas", value: "concluida" },
        { label: "Canceladas", value: "cancelada" },
    ];
    const STATUS_TODOS_VALUE = "confirmada-enviar-transito-concluida-cancelada";
    const [selectedOptionsStatus, setSelectedOptionsStatus] = useState(STATUS_TODOS_OPTIONS);
    const [filtroStatus, setFiltroStatus] = useState(STATUS_TODOS_VALUE);

    var dataAtual = new Date();
    var ano = dataAtual.getFullYear();
    var mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    var dia = String(dataAtual.getDate()).padStart(2, '0');
    var dataFormatadaFinal = `${ano}-${mes}-${dia}`;
    dataAtual = new Date();
    dataAtual.setDate(dataAtual.getDate() - 14);
    ano = dataAtual.getFullYear();
    mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    dia = String(dataAtual.getDate()).padStart(2, '0');
    var dataFormatadaInicial = `${ano}-${mes}-${dia}`;
    const [filtroDataInicial, setFiltroDataInicial] = useState(dataFormatadaInicial);
    const [filtroDataFinal, setFiltroDataFinal] = useState(dataFormatadaFinal);

    const [mostrarFiltros, setMostrarFiltros] = useState(false);

    const [textObs, setTextObs] = useState("");

    const handleChangeTextObs = (event) => {
        setTextObs(event.target.value);
    };

    const handleApagarObs = (idVenda, idObs) => {
        setLoading(true);
        try {
            (async () => {
                const response = await apagarObsVenda(idObs);
                if (response != false) {
                    toast({
                        title: `Observação apagada com sucesso!`,
                        status: 'success',
                        isClosable: true,
                    })
                    const pedidoEncontrado = pedidos.find(pedido => pedido.id_taga === idVenda);
                    if (pedidoEncontrado) {
                        const obs_pedidoIndex = pedidoEncontrado.observacoes.findIndex(obs => obs.id === idObs);
                        if (obs_pedidoIndex !== -1) {
                            pedidoEncontrado.observacoes.splice(obs_pedidoIndex, 1);
                        }
                        setPedidos([...pedidos]);
                    }
                } else {
                    toast({
                        title: `Erro ao apagar observação.`,
                        status: 'error',
                        isClosable: true,
                    })
                }
                setLoading(false);
            })();
        }
        catch {

            toast({
                title: `Erro ao apagar observação.`,
                status: 'error',
                isClosable: true,
            })
            setLoading(false);
        }
    };

    const handleAddObs = async (idVenda, texto, files) => {
        if (texto.length === 0 && files && files.length == 0) {
            toast({
                title: `ERRO: Digite uma Observação!`,
                status: 'error',
                isClosable: true,
            });
            return false;
        }

        const userString = window.localStorage.getItem("user");
        const user = JSON.parse(userString);
        const formData = new FormData();

        formData.append("id", idVenda);
        formData.append("id_user", user.id);
        formData.append("obs", texto);

        files.forEach((file, index) => {
            formData.append(`files[]`, file);
        });

        setLoading(true);
        try {
            const response = await criarObsVenda(formData);
            if (response !== false) {
                toast({
                    title: `Observação adicionada com sucesso!`,
                    status: 'success',
                    isClosable: true,
                });
                setPedidos((prevPedidos) =>
                    prevPedidos.map((pedido) => {
                        if (pedido.id_taga === idVenda) {
                            const now = new Date();
                            const createdAt = now.toISOString();
                            const observacaoNew = {
                                id: response.observacao_id,
                                arquivos: response.arquivos,
                                observacao: texto,
                                usuario_id: user.id,
                                created_at: createdAt,
                            };
                            return {
                                ...pedido,
                                observacoes: [...pedido.observacoes, observacaoNew],
                            };
                        }
                        return pedido;
                    })
                );
            } else {
                toast({
                    title: `Erro ao adicionar observação.`,
                    status: 'error',
                    isClosable: true,
                });
            }
            setLoading(false);
        } catch {
            toast({
                title: `Erro ao adicionar observação.`,
                status: 'error',
                isClosable: true,
            });
            setLoading(false);
        }
    };

    const handleChangeFiltroStatus = (value) => {
        setFiltroStatus(value);
    };
    const handleSelectedOptionsStatusChange = (options) => {
        setSelectedOptionsStatus(options);
        let concatenatedString = "";
        if (options && options.length > 0) {
            for (let i = 0; i < options.length; i++) {
                if (options[i] && options[i].value) {
                    concatenatedString += options[i].value;
                    if (i !== options.length - 1) {
                        concatenatedString += "-";
                    }
                }
            }
        }
        handleChangeFiltroStatus(concatenatedString);
    };

    const formatarData = (data) => {
        if (data) {
            const dataObj = new Date(data);
            const dia = String(dataObj.getDate()).padStart(2, '0');
            const mes = String(dataObj.getMonth() + 1).padStart(2, '0');
            const ano = dataObj.getFullYear();
            return `${dia}/${mes}/${ano}`;
        } else {
            return "";
        }
    };

    function consultarVendas(carregar) {
        setLoadingLinear(true);
        if (carregar === true) {
            setLoading(true);
        }
        try {
            (async () => {
                const consulta = "busca=,status=" + filtroStatus + ",data_inicial=" + filtroDataInicial + ",data_final=" + filtroDataFinal + ",mktplaces=" + filtroMktplaces + ",fornecedores=" + filtroFornecedor
                    + ",produto=" + filtroProduto + ",cliente=" + filtroCliente + ",vendedor=,paginavendedor=1";

                const responseVendas = await getVendasML(consulta, filtroBusca);
                if (responseVendas !== false) {
                    setPedidos(responseVendas.vendas);
                    setTotalVendas(responseVendas.total)
                    setBuscaBool(false);
                } else {
                    setPedidos([]);
                    setBuscaBool(true);
                }
                setLoadingLinear(false);
                setLoading(false);
            })();
        } catch {
            setLoadingLinear(false);
            setLoading(false);
        }
    }

    const resetFiltros = () => {
        setFiltroBusca('');
        setFiltroProduto('');
        setFiltroCliente('');
        setFiltroDataInicial(dataFormatadaInicial);
        setFiltroDataFinal(dataFormatadaFinal);
        setSelectedOptionsStatus(STATUS_TODOS_OPTIONS);
        setFiltroStatus(STATUS_TODOS_VALUE);
        setFiltroFornecedor("morelate-vannucci-isapa-brcompany-autolatina-lng-cba-msam-blparts");
    };

    const handleAtribuicaoVenda = async (idVenda, status, negociacao = null) => {
        const userString = window.localStorage.getItem("user");
        const user = JSON.parse(userString);
        const donoDaAtribuicao = vendedorAtual
            ? { ...user, id: vendedorAtual.id, name: vendedorAtual.name }
            : user;

        var mensagemSucesso = "Você retirou a atribuição da Venda com sucesso";
        var mensagemErro = "Erro ao retirar atribuição da Venda";
        if (status == 1) {
            mensagemSucesso = "Venda atribuida com sucesso";
            mensagemErro = "Erro ao atribuir venda";
        }

        if (Array.isArray(idVenda)) {
            setLoading(true);
            (async () => {
                try {
                    const promises = idVenda.map(async id => {
                        const response = await setAtribuicaoVendaVendedor(id, status, vendedorSelecionado);
                        if (response === true) {
                            const pedidoEncontrado = pedidos.find(pedido => pedido.id_taga === id);
                            if (pedidoEncontrado) {
                                if (status == 1) {
                                    pedidoEncontrado.vendedor = donoDaAtribuicao;
                                } else {
                                    pedidoEncontrado.vendedor = null
                                }
                                setPedidos([...pedidos]);
                            }
                            return true;
                        } else {
                            toast({
                                title: mensagemErro,
                                status: 'error',
                                isClosable: true,
                                duration: 100,
                            });
                            return false;
                        }
                    });

                    const results = await Promise.all(promises);
                    const todasAsRequisicoesForamConcluidasComSucesso = results.every(result => result === true);

                    if (todasAsRequisicoesForamConcluidasComSucesso) {
                        setLoading(false);
                        toast({
                            title: mensagemSucesso,
                            status: 'success',
                            isClosable: true,
                        })
                    }
                } catch (error) {
                    toast({
                        title: mensagemErro + `: ${error.message}`,
                        status: 'error',
                        isClosable: true,
                        duration: 100,
                    });
                    setLoading(false);
                }
            })();
        } else {
            // Devolve a mensagem de erro (a janela de confirmacao mostra) ou null no sucesso.
            setLoading(true);
            try {
                const response = await setAtribuicaoVendaVendedor(idVenda, status, vendedorSelecionado, negociacao);
                if (response !== true) {
                    const erro = response?.erro || mensagemErro;
                    toast({ title: mensagemErro, description: response?.erro, status: 'error', isClosable: true });
                    return erro;
                }
                toast({
                    title: mensagemSucesso,
                    status: 'success',
                    isClosable: true,
                })

                const pedidoEncontrado = pedidos.find(pedido => pedido.id_taga === idVenda);
                if (pedidoEncontrado) {
                    if (status == 1) {
                        pedidoEncontrado.vendedor = donoDaAtribuicao;
                    } else {
                        pedidoEncontrado.vendedor = null
                    }
                    setPedidos([...pedidos]);
                }
                if (negociacao) {
                    carregarNegociacoes([idVenda]);
                }
                return null;
            } catch {
                toast({
                    title: mensagemErro,
                    status: 'error',
                    isClosable: true,
                })
                return mensagemErro;
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <>
            <ScrollToTop />
            {loading && <Preloader />}
            <Box ml={{ base: "0", md: "8" }} bg="gray.50" minH="100vh" pb={10}>
                <Box maxW={{ base: "100%", md: "92%", lg: "85%" }} mx="auto" px={{ base: 3, md: 6 }} pt={8} pb={4}>
                    <Flex justify="space-between" align={{ base: 'stretch', md: 'center' }} gap={4} direction={{ base: 'column', md: 'row' }}>
                        <HStack spacing={3} mb={1}>
                            <Flex
                                bg="orange.50"
                                w={11}
                                h={11}
                                borderRadius="lg"
                                align="center"
                                justify="center"
                            >
                                <Icon as={FaShoppingCart} color="#F68633" boxSize={5} />
                            </Flex>
                            <VStack align="flex-start" spacing={0}>
                                <Heading size="lg" color="gray.800">Vendas Vendedor</Heading>
                                <Text fontSize="sm" color="gray.500">
                                    Pedidos atribuídos e gestão de comissões
                                </Text>
                            </VStack>
                        </HStack>
                        <Box minW={{ base: '100%', md: '240px' }}>
                            <Text fontSize="xs" fontWeight="semibold" color="gray.500" textTransform="uppercase" letterSpacing="wider" mb={1}>
                                Vendedor
                            </Text>
                            <Select
                                size="md"
                                bg="white"
                                borderRadius="md"
                                borderColor="gray.300"
                                fontWeight="semibold"
                                value={vendedorSelecionado ?? ''}
                                onChange={(e) => setVendedorSelecionado(Number(e.target.value))}
                                isDisabled={!ehAdmin}
                                title={ehAdmin ? undefined : 'Somente administradores trocam o vendedor'}
                            >
                                {vendedoresVisiveis.map((v) => (
                                    <option key={v.id} value={v.id}>{v.name}</option>
                                ))}
                            </Select>
                        </Box>
                    </Flex>
                </Box>

                <Tabs colorScheme="orange" variant="enclosed" mt={2} isLazy>
                    <Box maxW={{ base: "100%", md: "92%", lg: "85%" }} mx="auto" px={{ base: 3, md: 6 }}>
                        <TabList borderBottomWidth="2px" borderBottomColor="gray.200">
                            <Tab fontWeight="bold" fontSize={{ base: "13px", md: "15px" }} _selected={{ color: '#F68633', borderColor: 'inherit', borderBottomColor: 'white', bg: 'white' }}>
                                Vendas
                            </Tab>
                            <Tab fontWeight="bold" fontSize={{ base: "13px", md: "15px" }} _selected={{ color: '#F68633', borderColor: 'inherit', borderBottomColor: 'white', bg: 'white' }}>
                                Comissões
                            </Tab>
                            <Tab fontWeight="bold" fontSize={{ base: "13px", md: "15px" }} _selected={{ color: '#F68633', borderColor: 'inherit', borderBottomColor: 'white', bg: 'white' }}>
                                Pagamentos
                            </Tab>
                        </TabList>
                    </Box>
                    <TabPanels>
                        <TabPanel px={0} pt={4}>
                            <MetricasVendas metricas={metricas} loading={loadingMetricas} userId={vendedorSelecionado} />

                            <Box maxW={{ base: "100%", md: "92%", lg: "85%" }} mx="auto" px={{ base: 3, md: 6 }} mb={4} mt={4}>
                                <Flex
                                    bg="white"
                                    borderWidth="1px"
                                    borderColor="gray.200"
                                    borderRadius="xl"
                                    boxShadow="sm"
                                    p={{ base: 3, md: 4 }}
                                    direction="column"
                                    gap={3}
                                >
                                    <Flex justify="space-between" align="center" gap={3} flexWrap="wrap">
                                        <HStack spacing={2}>
                                            <Icon as={FaSlidersH} color="gray.500" />
                                            <Text fontWeight="semibold" color="gray.700" fontSize="sm">Filtros de busca</Text>
                                        </HStack>
                                        <Button
                                            size="sm"
                                            variant="ghost"
                                            colorScheme="orange"
                                            onClick={() => setMostrarFiltros(!mostrarFiltros)}
                                        >
                                            {mostrarFiltros ? "Ocultar" : "Mostrar filtros"}
                                        </Button>
                                    </Flex>

                                    <Collapse in={mostrarFiltros} animateOpacity style={{ overflow: "visible" }}>
                                        <Grid
                                            templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }}
                                            gap={3}
                                            mb={3}
                                        >
                                            <FormControl>
                                                <FormLabel fontSize="xs" fontWeight="semibold" color="gray.600">Venda</FormLabel>
                                                <Input size="sm" borderRadius="md" placeholder="ID Venda" value={filtroBusca} onChange={(e) => setFiltroBusca(e.target.value)} />
                                            </FormControl>

                                            <FormControl>
                                                <FormLabel fontSize="xs" fontWeight="semibold" color="gray.600">Produto</FormLabel>
                                                <Input size="sm" borderRadius="md" placeholder="SKU, Nome ou Código Global" value={filtroProduto} onChange={(e) => setFiltroProduto(e.target.value)} />
                                            </FormControl>

                                            <FormControl>
                                                <FormLabel fontSize="xs" fontWeight="semibold" color="gray.600">Cliente</FormLabel>
                                                <Input size="sm" borderRadius="md" placeholder="Nome do Cliente" value={filtroCliente} onChange={(e) => setFiltroCliente(e.target.value)} />
                                            </FormControl>

                                            <FormControl>
                                                <FormLabel fontSize="xs" fontWeight="semibold" color="gray.600">Data Inicial</FormLabel>
                                                <Input size="sm" borderRadius="md" type="date" value={filtroDataInicial} onChange={(e) => setFiltroDataInicial(e.target.value)} />
                                            </FormControl>

                                            <FormControl>
                                                <FormLabel fontSize="xs" fontWeight="semibold" color="gray.600">Data Final</FormLabel>
                                                <Input size="sm" borderRadius="md" type="date" value={filtroDataFinal} onChange={(e) => setFiltroDataFinal(e.target.value)} />
                                            </FormControl>

                                            <FormControl>
                                                <FormLabel fontSize="xs" fontWeight="semibold" color="gray.600">Status</FormLabel>
                                                <MultipleSelect selectedOptionsStatus={selectedOptionsStatus} handleSelectedOptionsStatusChange={handleSelectedOptionsStatusChange} />
                                            </FormControl>
                                            <FormControl>
                                                <FormLabel fontSize="xs" fontWeight="semibold" color="gray.600">Fornecedores</FormLabel>
                                                <MultipleSelectFornecedoresVendas selectedOptionsStatus={selectedOptionsStatusFornecedor} handleSelectedOptionsStatusChange={handleSelectedOptionsFornecedoresChange} />
                                            </FormControl>
                                        </Grid>

                                        <HStack spacing={2}>
                                            <Button size="sm" bg="#F68633" color="white" _hover={{ bg: '#E07520' }} onClick={() => consultarVendas(true)}>
                                                Filtrar
                                            </Button>
                                            <Button size="sm" variant="outline" colorScheme="gray" onClick={resetFiltros}>
                                                Limpar
                                            </Button>
                                        </HStack>
                                    </Collapse>
                                </Flex>
                            </Box>

                            <Box maxW={{ base: "100%", md: "92%", lg: "85%" }} mx="auto" px={{ base: 3, md: 6 }} mb={3}>
                                <HStack spacing={2} flexWrap="wrap">
                                    <Button
                                        size="sm"
                                        variant={filtroAtribuicao === 'todos' ? 'solid' : 'outline'}
                                        colorScheme={filtroAtribuicao === 'todos' ? 'gray' : 'gray'}
                                        bg={filtroAtribuicao === 'todos' ? 'gray.700' : 'white'}
                                        color={filtroAtribuicao === 'todos' ? 'white' : 'gray.700'}
                                        _hover={filtroAtribuicao === 'todos' ? { bg: 'gray.800' } : { bg: 'gray.50' }}
                                        onClick={() => setFiltroAtribuicao('todos')}
                                    >
                                        Todos ({pedidos.length})
                                    </Button>
                                    <Button
                                        size="sm"
                                        variant={filtroAtribuicao === 'atribuidas' ? 'solid' : 'outline'}
                                        colorScheme="green"
                                        onClick={() => setFiltroAtribuicao('atribuidas')}
                                    >
                                        Vendas Atribuídas ({pedidos.filter(p => p.vendedor).length})
                                    </Button>
                                    <Button
                                        size="sm"
                                        variant={filtroAtribuicao === 'sem_atribuicao' ? 'solid' : 'outline'}
                                        colorScheme="orange"
                                        onClick={() => setFiltroAtribuicao('sem_atribuicao')}
                                    >
                                        Sem Atribuição ({pedidos.filter(p => !p.vendedor).length})
                                    </Button>
                                </HStack>
                            </Box>

                            <Box maxW={{ base: "100%", md: "92%", lg: "85%" }} mx="auto" px={{ base: 3, md: 6 }} mb={4}>
                                <Flex
                                    align="center"
                                    justify="space-between"
                                    bg="white"
                                    borderWidth="1px"
                                    borderColor="gray.200"
                                    borderRadius="lg"
                                    px={4}
                                    py={2.5}
                                >
                                    <Text fontSize="sm" color="gray.600">
                                        Exibindo <Text as="span" fontWeight="bold" color="gray.800">{pedidosFiltrados.length}</Text>
                                        {filtroAtribuicao !== 'todos' && <Text as="span" color="gray.500"> de {pedidos.length}</Text>}
                                        {' '}{pedidosFiltrados.length === 1 ? 'venda' : 'vendas'} de {formatarData(filtroDataInicial)} a {formatarData(filtroDataFinal)}
                                    </Text>
                                    {loadingLinear && (
                                        <Text fontSize="xs" color="orange.500" fontWeight="semibold">Carregando...</Text>
                                    )}
                                </Flex>
                                {loadingLinear && <Progress mt={1} size='xs' isIndeterminate colorScheme="orange" borderRadius="full" />}
                            </Box>

                            <Box maxW={{ base: "100%", md: "92%", lg: "85%" }} mx="auto" px={{ base: 3, md: 6 }} pb={6}>
                                {(!pedidosFiltrados || pedidosFiltrados.length === 0) && !loading ? (
                                    <Flex
                                        direction="column"
                                        align="center"
                                        justify="center"
                                        py={20}
                                        bg="white"
                                        borderWidth="1px"
                                        borderColor="gray.200"
                                        borderStyle="dashed"
                                        borderRadius="xl"
                                    >
                                        <Icon as={FaInbox} boxSize={12} color="gray.300" mb={3} />
                                        <Text fontSize="lg" fontWeight="semibold" color="gray.600" mb={1}>
                                            Nenhuma venda encontrada
                                        </Text>
                                        <Text fontSize="sm" color="gray.500">
                                            {filtroAtribuicao !== 'todos'
                                                ? 'Nenhuma venda no filtro selecionado. Tente "Todos".'
                                                : 'Ajuste os filtros e tente novamente.'}
                                        </Text>
                                    </Flex>
                                ) : (
                                    <VStack align="stretch" spacing={3}>
                                        {pedidosFiltrados.map((pedido) => (
                                            <CardPedido
                                                key={pedido.id}
                                                pedido={pedido}
                                                onClickAtribuir={openModalConfirmAtribuicao}
                                                handleAddObs={handleAddObs}
                                                handleApagarObs={handleApagarObs}
                                                textObs={textObs}
                                                handleChangeTextObs={handleChangeTextObs}
                                                negociacao={negociacoes[pedido.id_taga]}
                                                podeEditarNegociacao={podeEditarNegociacao(pedido)}
                                                onEditarNegociacao={setPedidoNegociacao}
                                            />
                                        ))}
                                    </VStack>
                                )}
                            </Box>
                        </TabPanel>
                        <TabPanel px={0} pt={4}>
                            <PainelComissoes userId={vendedorSelecionado} />
                        </TabPanel>
                        <TabPanel px={0} pt={4}>
                            <PainelPagamentos userId={vendedorSelecionado} />
                        </TabPanel>
                    </TabPanels>
                </Tabs>

                <Modal
                    isOpen={isModalOpenConfirmAtribuicao}
                    onClose={handleCancelAtribuicao}
                    isCentered
                    size={vendaAtribuicao && !vendaAtribuicao.vendedor ? { base: 'full', sm: 'lg' } : 'md'}
                    scrollBehavior="inside"
                >
                    <ModalOverlay backdropFilter="blur(2px)" />
                    <ModalContent borderRadius={{ base: vendaAtribuicao && !vendaAtribuicao.vendedor ? 0 : 'xl', sm: 'xl' }}>
                        <ModalHeader>Confirmação</ModalHeader>
                        <ModalCloseButton isDisabled={salvandoAtribuicao} />
                        <ModalBody>
                            {
                                vendaAtribuicao &&
                                (vendaAtribuicao.vendedor ?
                                    (
                                        <Text fontSize="md" mb={4} >Você deseja {" "}
                                            <Text as="span" fontWeight={"bold"} color="red.500">
                                                remover
                                            </Text>{" "} a atribuição da venda <Text as="span" fontWeight="bold">#{vendaAtribuicao.id}</Text>?</Text>
                                    )
                                    :
                                    (
                                        <Text fontSize="md" mb={4}>
                                            Você deseja{" "}
                                            <Text as="span" fontWeight={"bold"} color="green.500">
                                                atribuir
                                            </Text>{" "}
                                            a venda <Text as="span" fontWeight="bold">#{vendaAtribuicao.id}</Text>
                                            {vendedorAtual && vendedorAtual.id !== usuario?.id
                                                ? <> para <Text as="span" fontWeight="bold">{vendedorAtual.name}</Text>?</>
                                                : ' a si?'}
                                        </Text>
                                    )
                                )
                            }
                            {vendaAtribuicao && !vendaAtribuicao.vendedor && (
                                <>
                                    <Divider mb={4} />
                                    <Text fontSize="sm" fontWeight="semibold" color="gray.700" mb={1}>Dados da negociação</Text>
                                    <Text fontSize="xs" color="gray.500" mb={3}>
                                        {gerencia
                                            ? 'Opcional para administradores.'
                                            : 'Informe ao menos o canal de contato. O resto é opcional e pode ser completado depois.'}
                                    </Text>
                                    <FormNegociacao
                                        valor={formNegociacao}
                                        onChange={(v) => { setFormNegociacao(v); setErroAtribuicao(null); }}
                                        canalObrigatorio={!gerencia}
                                        isDisabled={salvandoAtribuicao}
                                    />
                                </>
                            )}
                            {erroAtribuicao && (
                                <Alert status="error" borderRadius="md" mt={4} fontSize="sm">
                                    <AlertIcon />
                                    {erroAtribuicao}
                                </Alert>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button colorScheme="green" mr={3} onClick={handleClickAtribuirVenda} isLoading={salvandoAtribuicao}>
                                Confirmar
                            </Button>
                            <Button variant="ghost" onClick={handleCancelAtribuicao} isDisabled={salvandoAtribuicao}>
                                Cancelar
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>

                <ModalNegociacao
                    isOpen={!!pedidoNegociacao}
                    onClose={() => setPedidoNegociacao(null)}
                    pedido={pedidoNegociacao}
                    negociacao={pedidoNegociacao ? negociacoes[pedidoNegociacao.id_taga] : null}
                    canalObrigatorio={!gerencia}
                    onSalvo={(id, n) => setNegociacoes((atual) => ({ ...atual, [id]: n }))}
                />
            </Box>
        </>
    );
};

export default VendasVendedor;
